import Icon from "./IconBase.js";
const NotMarkedMB = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.66666 8.66665H7.33333V4.66665H8.66666M8.66666 11.3333H7.33333V9.99998H8.66666M7.99999 1.33331C7.12452 1.33331 6.25761 1.50575 5.44877 1.84078C4.63993 2.17581 3.90501 2.66688 3.28595 3.28593C2.03571 4.53618 1.33333 6.23187 1.33333 7.99998C1.33333 9.76809 2.03571 11.4638 3.28595 12.714C3.90501 13.3331 4.63993 13.8241 5.44877 14.1592C6.25761 14.4942 7.12452 14.6666 7.99999 14.6666C9.7681 14.6666 11.4638 13.9643 12.714 12.714C13.9643 11.4638 14.6667 9.76809 14.6667 7.99998C14.6667 7.1245 14.4942 6.25759 14.1592 5.44876C13.8242 4.63992 13.3331 3.90499 12.714 3.28593C12.095 2.66688 11.3601 2.17581 10.5512 1.84078C9.74238 1.50575 8.87547 1.33331 7.99999 1.33331Z"
          fill="#D29822"
        />
      </svg>
    </Icon>
  );
};
export default NotMarkedMB;
